import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const TextButton = ({
  children,
  className,
  type = "button",
  disabled,
  onClick,
  ...rest
}) => (
  <button
    type={type}
    disabled={disabled}
    className={classNames(
      "border-none",
      "bg-transparent",
      "p-0",
      "m-0",
      "font-bold",
      "text-black",
      "line-height-100",
      "cursor-pointer",
      "underline",
      "hover:opacity-85",
      "focus-visible:outline-link",
      "active:opacity-70",
      "disabled:opacity-50",
      className
    )}
    style={{ fontSize: "inherit" }}
    onClick={onClick}
    {...rest}
  >
    {children}
  </button>
);

TextButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};

export default TextButton;
